// Global fetch patch: attaches the operator JWT to backend API calls and
// redirects to the login screen when the token is missing/expired.
// Token lives in localStorage so a single login covers the main app AND the
// Operator Dashboard, across tabs (single sign-in).
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'wve_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem('wve_auth');
};

const originalFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  const isBackend = BACKEND && url.startsWith(BACKEND);
  const isLogin = url.includes('/api/auth/login');

  if (isBackend && !isLogin) {
    const token = getToken();
    if (token) {
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
      headers.set('Authorization', `Bearer ${token}`);
      init = { ...init, headers };
    }
  }

  const response = await originalFetch(input, init);

  if (isBackend && !isLogin && response.status === 401 && getToken()) {
    clearAuth();
    if (window.location.pathname !== '/') {
      window.location.href = '/';
    } else {
      window.location.reload();
    }
  }
  return response;
};
